import { EMAIL_COLORS } from '../../../shared/constants/brandColors';

const FREQUENCY_LABELS = {
  weekly: 'weekly',
  'bi-weekly': 'every 2 weeks',
  monthly: 'monthly',
};

/**
 * Builds invite content for both email (HTML) and WhatsApp (plain text).
 * Single source of truth — never call this separately per channel.
 */
export const buildInviteContent = ({
  groupName,
  adminName,
  contributionAmount,
  frequency,
  positions,
  firstDueDate,
  inviteUrl,
}) => {
  const amountFormatted = `$${parseFloat(contributionAmount).toFixed(2)}`;
  const frequencyLabel = FREQUENCY_LABELS[frequency] || frequency;
  const positionList = Array.isArray(positions) ? positions.join(', ') : positions;
  const subject = `You've been invited to join ${groupName} on EsuSol`;

  const text = [
    `Hi! You've been invited to join *${groupName}* on EsuSol.`,
    '',
    `Admin: ${adminName}`,
    `Contribution: ${amountFormatted} per hand, paid ${frequencyLabel}`,
    `Your hand(s): ${positionList}`,
    `First contribution due: ${firstDueDate}`,
    '',
    'Tap the link below to review the group agreement and activate your membership:',
    inviteUrl,
    '',
    'This link expires in 7 days.',
  ].join('\n');

  const html = `
<!DOCTYPE html>
<html>
<body style="margin:0;padding:0;background:${EMAIL_COLORS.pageBg};font-family:sans-serif;">
  <div style="max-width:560px;margin:40px auto;background:${EMAIL_COLORS.surface};border-radius:12px;overflow:hidden;border:1px solid ${EMAIL_COLORS.border};">
    <div style="background:${EMAIL_COLORS.brand};padding:28px 32px;">
      <h1 style="color:${EMAIL_COLORS.onBrand};margin:0;font-size:22px;font-weight:700;">EsuSol</h1>
      <p style="color:${EMAIL_COLORS.brandSubtle};margin:6px 0 0;font-size:14px;">Savings Group Management</p>
    </div>
    <div style="padding:32px;">
      <h2 style="color:${EMAIL_COLORS.heading};font-size:18px;margin:0 0 8px;">You're invited to join ${groupName}</h2>
      <p style="color:${EMAIL_COLORS.muted};font-size:14px;margin:0 0 24px;">
        ${adminName} has added you as a member. Review the details below and accept your invitation.
      </p>

      <table style="width:100%;border-collapse:collapse;background:${EMAIL_COLORS.tableBg};border-radius:8px;margin-bottom:24px;">
        <tr>
          <td style="padding:10px 14px;color:${EMAIL_COLORS.muted};font-size:13px;">Group</td>
          <td style="padding:10px 14px;color:${EMAIL_COLORS.heading};font-size:13px;font-weight:600;">${groupName}</td>
        </tr>
        <tr style="background:${EMAIL_COLORS.tableStripe};">
          <td style="padding:10px 14px;color:${EMAIL_COLORS.muted};font-size:13px;">Contribution</td>
          <td style="padding:10px 14px;color:${EMAIL_COLORS.heading};font-size:13px;font-weight:600;">${amountFormatted} per hand, ${frequencyLabel}</td>
        </tr>
        <tr>
          <td style="padding:10px 14px;color:${EMAIL_COLORS.muted};font-size:13px;">Your hand(s)</td>
          <td style="padding:10px 14px;color:${EMAIL_COLORS.heading};font-size:13px;font-weight:600;">${positionList}</td>
        </tr>
        <tr style="background:${EMAIL_COLORS.tableStripe};">
          <td style="padding:10px 14px;color:${EMAIL_COLORS.muted};font-size:13px;">First due date</td>
          <td style="padding:10px 14px;color:${EMAIL_COLORS.heading};font-size:13px;font-weight:600;">${firstDueDate}</td>
        </tr>
      </table>

      <div style="text-align:center;margin-bottom:24px;">
        <a href="${inviteUrl}" style="display:inline-block;background:${EMAIL_COLORS.button};color:${EMAIL_COLORS.onButton};padding:14px 32px;border-radius:8px;text-decoration:none;font-weight:600;font-size:15px;">
          Join This Group →
        </a>
      </div>

      <p style="color:${EMAIL_COLORS.footnote};font-size:12px;text-align:center;margin:0;">
        This link expires in 7 days. Do not share it — it is personal to you.
      </p>
    </div>
  </div>
</body>
</html>`.trim();

  return { subject, text, html };
};
